import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { selectDevDbWhole, selectDraftFreshness, selectRouteSimple } from '../redux/selectors';
import { actionAdminDbInitialSeed, actionAdminDbDelete, actionDevSimDbGet } from '../redux/ter-actions.js';
import config from '../utils/config.js';
import Komentar from './Komentar';
import Btn from './Btn';
import ColumnWidth from './ColumnWidth.js';
import Spinner from './Spinner';
import SpinnerRow from './SpinnerRow';
import SklopiviMini from './SklopiviMini';
import JSDisplayValue from './JSDisplayValue';
import CardCollapsible from './CardCollapsible';
import { dynamicjs_load_script_file, dynamicjs_load_script_string } from '../utils/frfr-dynamic-js-utils';


//
const _reload = () => {
  window.location.reload(true); // Reloads the current page from the server
};


//
// TODO dynamic
const _cb_test_1 = () => {
  // Here, do whatever you want
  console.log('Hello! _cb_test_1');
  if (window.__test_dynamicjs_test_1) {
    console.log(window.__test_dynamicjs_test_1.x);
    window.__test_dynamicjs_test_1.f();
  }
};
const _cb_test_2 = () => {
  // Here, do whatever you want
  console.log('Hello! _cb_test_2');
  if (window.__test_dynamicjs_test_2) {
    console.log(window.__test_dynamicjs_test_2.x);
    window.__test_dynamicjs_test_2.f();
  }
};


//
const DisplaySimDbWhole = (props) => {
  const dispatch = useDispatch();
  const route = useSelector(selectRouteSimple);
  const _dev_db_whole = useSelector(selectDevDbWhole);
  useEffect(() => {
    // kada se pormeni .saved uzimamo celu bazu da bismo analizirali
    dispatch(actionDevSimDbGet());
  }, [route.freshness]); // Only re-run the effect if freshness changes
  return (
    <JSDisplayValue val={_dev_db_whole} />
  );
};


// DEFAULT COMPONENT
const StranaDevPanel = (props) => {
  const dispatch = useDispatch();

  /*
  const route = props.route;

  useEffect(() => {
    // kada se pormeni .saved uzimamo celu bazu da bismo analizirali
    dispatch(actionDevSimDbGet());
  }, [route.freshness]); // Only re-run the effect if freshness changes

  const _db = props._dev_db_whole;
  */

  const _obrisiBazu = () => {
    if (window.confirm("Da li ste sigurni da želite da obrišete bazu?")) {
      //
      dispatch(actionAdminDbDelete());
    }
  };

  const _initialSeedBaze = () => {
    if (window.confirm("Da li ste sigurni da želite da upisete inicijalne podatke u bazu? To ce obrisati sve prethodno iz baze.")) {
      //
      dispatch(actionAdminDbInitialSeed());
      // console.log('test 3');
    }
  };


  const handleClick_dynamicjs_test_1 = () => {
    //
    dynamicjs_load_script_file("/static/js/dynamicjs-test-1.js", _cb_test_1);
  };

  const handleClick_dynamicjs_test_2 = () => {
    //
    const js_script_str = `
// javascript string

console.log('Hello! javascript string');

window.__test_dynamicjs_test_2 = {
  x: "Hello I'am x",
  f: () => {
    console.log("Hello I'am f");
  }
};`;
    dynamicjs_load_script_string(js_script_str, _cb_test_2);
    console.log('now try to check is scritp loaded synchronously');
    _cb_test_2();
  };


  return (
    <>
      <ColumnWidth w={480}>
        <h1>Dev Panel</h1>

        <Komentar>Najpre morate obaviti brisnje baze zatim seed inicijalnih podataka. I na kraju reload kako bi apliakcija ponovo proverila stanje ulogovanog korisnika</Komentar>

        <p>1) potpuno brisanje baze:</p>
        <Btn
          title="Obriši celu bazu"
          handleClick={_obrisiBazu}
        />

        <p>2) inicijalni unos nosioca u bazu:</p>
        <Btn
          title="Seed podataka u bazu"
          handleClick={_initialSeedBaze}
        />

        <p>3) Potpuni reload aplikacije sa svežim fajlovima</p>
        <Btn
          title="Osveži forsirano"
          handleClick={handleClick_dynamicjs_test_1}
        />

        <p></p>
        <p></p>
        <Spinner />
        <Spinner />
        <SpinnerRow />
        <SpinnerRow />
        <SpinnerRow />
        <p></p>
        <p></p>
        <SklopiviMini title={'BAZA prikaz'}>
          <DisplaySimDbWhole />
        </SklopiviMini>
        <p></p>
        <p></p>
        <br />
        <br />
        <CardCollapsible title="dynamic js testiranje">
          <p>dynamic js test 1</p>
          <Btn
            title="dynamic js test 1"
            handleClick={handleClick_dynamicjs_test_1}
          />
          <p>dynamic js test 2</p>
          <Btn
            title="dynamic js test 1"
            handleClick={handleClick_dynamicjs_test_2}
          />
        </CardCollapsible>
        <p></p>
        <p></p>

      </ColumnWidth>
    </>
  );
};

export default StranaDevPanel;